module.exports = __webpack_public_path__ + "static/media/logo_help.6f6366fb.svg";